/**
 * 客户端席位授权服务
 */

import { apiService } from './api'
import type {
  ClientSeatApiResponse,
  ClientSeatSummary,
  ClientSeatUsersData,
} from '@/types/clientSeat'

const CLIENT_SEAT_ENDPOINT = '/api/user/client-seats' as const

export async function getClientSeatSummary(): Promise<ClientSeatSummary> {
  const response = await apiService.get<ClientSeatApiResponse<ClientSeatSummary>>(
    `${CLIENT_SEAT_ENDPOINT}/summary`
  )
  return response.data
}

export async function listClientSeatUsers(): Promise<ClientSeatUsersData> {
  const response = await apiService.get<ClientSeatApiResponse<ClientSeatUsersData>>(
    `${CLIENT_SEAT_ENDPOINT}/users`
  )
  return response.data
}

export async function assignClientSeat(userId: string): Promise<void> {
  await apiService.post<ClientSeatApiResponse<{ message: string }>>(
    `${CLIENT_SEAT_ENDPOINT}/assign`,
    { userId }
  )
}

export async function unassignClientSeat(userId: string): Promise<void> {
  await apiService.post<ClientSeatApiResponse<{ message: string }>>(
    `${CLIENT_SEAT_ENDPOINT}/unassign`,
    { userId }
  )
}
